import React, { useState, useEffect } from 'react'
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import EmailPhoneCombine from '../../jsx/components/fields/emailPhoneField'
import PrimaryButton from '../../jsx/components/button/primaryButton'
import { useDispatch, useSelector } from "react-redux";
import {
    emailValidation,
    noSpaceOnChange,
    phoneValidation,
} from "../../functions/validations";
import { btnInvite, btnInviteFriends } from '../../dataBaseFile/alert'
import { validEmail_OR_MobileNumberText } from '../../dataBaseFile/error'
import TextArea from '../../jsx/components/fields/textArea'
import { txtMessage, txtTypeComments } from '../../dataBaseFile/label'
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster'
import ResponceForAPI from '../../component/backDrop/responcesForAPI'
import { MdContentCopy } from 'react-icons/md'
import { sendProCodeInviteLinkApi } from '../../service/api/messaging/sendProCodeInviteLinkApi';
const SendProCodeInviteLink = ({ sendProCodeModalTrigger, handleCloseSendProCodeModal, proCode }) => {
    const dispatch = useDispatch();
    const { permissionArr, userName, referralLink } = useSelector((state) => state.user);

    const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
    const [emailPhoneValue, setEmailPhoneValue] = useState("");
    const [codeValue, setCodeValue] = useState(1);
    const [isPhone, setIsPhone] = useState(false);
    const [message, setMessage] = useState(`${userName?.split(" ", 1) || "Chilll"}  is inviting you to join to the Chilll call.`);
    const [isErrorButton, setIsErrorButton] = useState(false);
    const [isFreeSR, setIsFreeSR] = useState(false);


    const [loaderActive, setLoaderActive] = useState(true);

    const [apiResponce, setApiResponse] = useState(false);
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);
    const [responceMsg, setResponceMsg] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (phoneValidation(emailPhoneValue) || emailValidation(emailPhoneValue)) {
            setLoaderActive(false);
            setApiResponse(true);
            if (isPhone) {

                const formData = new FormData();
                formData.append("invitee_email_chr", "");
                formData.append("phone_code_id_int", parseInt(codeValue));
                formData.append("is_free_sr", isFreeSR ? 1 : 0);
                formData.append("invitee_phone_number_int", parseInt(emailPhoneValue));
                formData.append("message_to_end_user_chr", message);

                dispatch(
                    sendProCodeInviteLinkApi(
                        formData,
                        (res) => {
                            setResponceMsg(res.data.message);
                            setEmailPhoneValue("");
                            setMessage("");
                            setLoaderActive(true);
                            handleCloseSendProCodeModal()

                            setToasterType("success")
                            setApiResponse(false);

                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);


                        },
                        (err) => {
                            setResponceMsg(err.data.message);
                            setLoaderActive(true);
                            setIsErrorButton(true);

                            setToasterType("error");
                            setApiResponse(false);

                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);


                        }
                    )
                );
            } else if (!isPhone) {
                let details = {
                    user_id_ids: localStorage.getItem("user_id"),
                    invitee_email_chr: emailPhoneValue,
                    phone_code_id_int: null,
                    invitee_phone_number_int: null,
                    message_to_end_user_chr: message
                };

                const formData = new FormData();
                formData.append("invitee_email_chr", emailPhoneValue);
                // formData.append("phone_code_id_int", null);
                formData.append("is_free_sr", isFreeSR ? 1 : 0);
                // formData.append("invitee_phone_number_int", null);
                formData.append("message_to_end_user_chr", message);

                dispatch(
                    sendProCodeInviteLinkApi(
                        formData,
                        (res) => {
                            setResponceMsg(res.data.message);
                            setEmailPhoneValue("");
                            setMessage("");
                            setLoaderActive(true);
                            handleCloseSendProCodeModal()

                            setToasterType("success")
                            setApiResponse(false);

                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        },
                        (err) => {
                            setResponceMsg(err.data.message);
                            setLoaderActive(true);
                            setIsErrorButton(true);

                            setToasterType("error");
                            setApiResponse(false);

                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);

                        }
                    )
                );
            }
        } else {
            setIsEmailPhoneVal(true);
        }
    };

    const handleEmailPhone = (e) => {
        setIsEmailPhoneVal(false);
        noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);
    };
    const handleDropdownValue = (e) => {
        // setCodeValue(e.target.value);
        setCodeValue(e);
    };


    useEffect(() => {
        const dot = ".";
        const leng = emailPhoneValue.length - 1;
        if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
            if (emailPhoneValue.length < 11) {
                setIsPhone(true);
            } else {
                setIsPhone(false);
            }
        } else {
            setIsPhone(false);
        }
        if (emailPhoneValue === "") {
            setIsPhone(false);
        }


    }, [emailPhoneValue]);

    function handleEmailPhoneBlur() {
        if (isPhone) {
            if (!phoneValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true)

            }
        }
        else {

            if (!emailValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true)
            }

        }
    }

    const handleMessage = (e) => {
        setMessage(e.target.value);
    };

    const [tabsToggleInvite, setTabsToggleInvite] = useState(1);


    const copyToClipboard = () => {
        navigator.clipboard.writeText(`${proCode}`);
        setResponceMsg("Code copied to clipboard!");
        setToasterType("success");

        setHandleToaster(true);
        setTimeout(() => {
            setHandleToaster(false);
        }, 11000);
    }

    return (
        <>
            {/* <!-- Modal --> */}
            <Modal className="fade" show={sendProCodeModalTrigger} centered
            // onHide={handleCloseSendProCodeModal}
            >
                {/* <Modal.Header style={{ borderBottom: 'none' }}>
          <Modal.Title>{btnInviteFriends}</Modal.Title>
          <Button
            variant=""
            className="btn-close btn-close-invite"
            // onClick={() => setBasicModal(false)}
            onClick={() => handleCloseSendProCodeModal()}
          >

          </Button>
        </Modal.Header> */}

                <Modal.Body>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <div className='mx-0 row'>
                                <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                    <span onClick={() => handleCloseSendProCodeModal()} className='cursor-pointer'>
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <div className='mx-0 row mb-3'>
                                <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                    <span>
                                        {`Share your Pro code link`}
                                    </span>
                                </div>
                            </div>

                            <div className='mx-0 row mb-3'>
                                <div className='col-12 font-w500 fs-5 px-0 text-center '>
                                    <span>
                                        {`Send the Pro code to your friends to join Chilll call`}
                                    </span>
                                </div>
                            </div>

                            {/* Navigations send link */}
                            <div className='border-bottom m-0 mt-2 mb-3 overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'>
                                <div className='col-12 d-flex px-0 font-w500'>
                                    <div onClick={() => setTabsToggleInvite(1)} className='text-hovered col-6 px-0 align-items-cente cursor-pointer d-flex justify-content-center position-relative px-3 py-2' style={{}}>
                                        <span className={`text-hovered ${tabsToggleInvite === 1 ? "text-black" : "text-grey"} ${tabsToggleInvite === 1 && "fw-bold"}`} >{"Email or SMS"}</span>
                                        {tabsToggleInvite === 1 && <div className='position-absolute w-100 bottom-0 active-tab-bottom' > </div>}
                                    </div>

                                    <div onClick={() => setTabsToggleInvite(2)} className='text-hovered col-6 px-0 align-items-cente cursor-pointer d-flex justify-content-center position-relative px-3 py-2' style={{}}>
                                        <span className={`text-hovered ${tabsToggleInvite === 2 ? "text-black" : "text-grey"} ${tabsToggleInvite === 2 && "fw-bold"}`}>{"Copy code"}</span>
                                        {tabsToggleInvite === 2 && <div className='position-absolute w-100  bottom-0 active-tab-bottom'> </div>}
                                    </div>

                                </div>
                            </div>

                            {tabsToggleInvite === 1 &&
                                <form onSubmit={(e) => handleSubmit(e)} className='mt-4'>

                                    <EmailPhoneCombine
                                        inputValue={emailPhoneValue}
                                        handleChangeCode={handleDropdownValue}
                                        handleInputValue={handleEmailPhone}
                                        isEnteringNumber={isPhone}
                                        setIsEnteringNumber={setIsPhone}
                                        errorOccured={isEmailPhoneVal}
                                        handleOnBlur={handleEmailPhoneBlur}
                                        errorMessage={validEmail_OR_MobileNumberText}
                                        defaultCodeValue={codeValue}
                                        isRequired={true}
                                    />

                                    <TextArea
                                        labelName={txtMessage}
                                        placeholder={txtTypeComments}
                                        value={message}
                                        onChange={handleMessage}
                                        onBlur={() => { }}
                                    />

                                    <div className='col-12 d-flex align-items-center mb-4'>
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="typeOfService"
                                            name="typeOfService"
                                            onChange={(e) => { setIsFreeSR(!isFreeSR) }}
                                            value={isFreeSR}
                                            checked={isFreeSR}
                                        />
                                        <span
                                            className='ps-3 font-w600 fs-5 pt-1 cursor-pointer text-hovered'
                                            onClick={() => { setIsFreeSR(!isFreeSR) }}
                                        >
                                            {`make service call free`}
                                        </span>
                                    </div>

                                    <div className='d-flex align-items-center' style={{ justifyContent: 'flex-end', }}>

                                        <PrimaryButton
                                            buttonName={`SEND`}
                                            onClick={handleSubmit}
                                            isLoading={apiResponce}
                                            loadingMessage={"SENDING..."}
                                            style={{
                                                width: '100%',
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                            }}
                                        />
                                    </div>
                                </form>
                            }

                            {tabsToggleInvite === 2 &&
                                <>
                                    <div className=' mx-0 my-5 row text-center'>
                                        <div className='col-12 px-4 fs-5 font-w600'>
                                            <span>
                                                {`You can copy and send the code to your friends via any messenger you use to communicate.`}
                                            </span>

                                        </div>
                                    </div>



                                    <div className=' mx-0 row mt-4 p-1 fs-5 rounded shadow-sm '
                                        style={{
                                            background: 'rgba(244, 248, 255, 1)',
                                            border: '1px solid rgba(199, 212, 234, 1)',
                                        }}
                                    >
                                        <div className='col-11 px-0 d-flex  '>

                                            <div className='overflow-hidden p-2 d-flex align-items-center justify-content-center text-nowrap w-100 whitespace-nowrap' style={{ textOverflow: "ellipsis" }}>
                                                <span>
                                                    {proCode ? <>{`${proCode}`}</> : <>{"No code found"}</>}
                                                </span>
                                            </div>

                                        </div>

                                        <div className='col-1 px-0 fs-3 d-flex align-items-center justify-content-end text-black pe-2' style={{}}>
                                            <div className="tooltipCustom ">
                                                <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Copy to clipboard"}</span>
                                                <span
                                                    onClick={() => { copyToClipboard() }}
                                                    className={`cursor-pointer text-hovered ${proCode ? "op9" : "op2"}`}
                                                    style={{ pointerEvents: proCode ? "auto" : "none", }}
                                                >
                                                    <MdContentCopy />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }

                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
            {/* {apiResponce && <ResponceForAPI show={apiResponce} />} */}
        </>
    )
}

export default SendProCodeInviteLink;